import { PermissionRequestListActionsTypes } from './actions';
import { createAction, props } from '@ngrx/store';
import { RequestPermission } from '@app-core/store/models/request-permision-counter.model';

export const getRequestPermission = createAction(
  PermissionRequestListActionsTypes.GET_REQUEST,
  props<{ params: any; statusFilter: string; filter: string }>()
);
export const getRequestPermissionSuccess = createAction(
  PermissionRequestListActionsTypes.GET_REQUEST_SUCCESS,
  props<{ requestlist: RequestPermission[]; count: number }>()
);
export const getRequestPermissionError = createAction(
  PermissionRequestListActionsTypes.GET_REQUEST_ERROR,
  props<{ payload: any }>()
);
